import React from 'react';
import './Interview.css';
import { images, interviewData } from '../../../constants';
import { FaAngleDoubleRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Interview = () => {
  return (
    <div className="interview__wrapper">
      
      {/* --- Sekcja Hero (Banner) --- */}
      <div className='interview__hero'>
        <div className='interview__hero-content'> 
            <h2>Wywiad z psychologiem</h2> 
            <h1 className="interview__hero-heading">Wywiad z psychologiem</h1>
        </div> 
        
        <div className='interview__breadcrumbs'>
          <Link to='/' className="interview__breadcrumbs-link">Strona Główna</Link>
          <FaAngleDoubleRight className='interview__breadcrumbs-icon' />
          <span className='interview__breadcrumbs-current'>Wywiad z psychologiem</span>
        </div>
      </div>

      <div className="interview__body">
        <div className="interview__container">
          
          {/* --- SIDEBAR (Lewa kolumna) --- */}
          <aside className="interview__sidebar">
             {/* A) Karta Eksperta */}
             <div className="interview__card interview__card--expert">
                <div className="interview__expert-photo">
                   <img 
                      src={images.marta_photo} // Upewnij się, że masz to zdjęcie w images
                      alt={interviewData.author.name} 
                   />
                </div>
                <div className="interview__expert-info">
                   <h4>{interviewData.author.name}</h4>
                   <p className="interview__expert-role">{interviewData.author.role}</p>
                   <div className="interview__separator"></div>
                   <p className="interview__expert-desc">
                       Ekspert Instytutu Psychologii<br/>
                       Specjalizacja: Hortiterapia
                   </p>
                </div>
             </div>

             {/* B) Karta Partnera */}
             <div className="interview__card interview__card--partner">
                <h4 className="interview__partner-title">
                   {interviewData.calmnestInfo.title}
                </h4>
                <div className="interview__separator interview__separator--full"></div>
                
                <div className="interview__partner-content">
                   {interviewData.calmnestInfo.content.map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                   ))}
                </div>

                <a 
                   href={interviewData.calmnestInfo.websiteUrl} 
                   target="_blank" 
                   rel="noopener noreferrer"
                   className="interview__partner-btn"
                >
                   Więcej o nas na<br/> 
                   <span>{interviewData.calmnestInfo.website}</span>
                </a>
             </div>
          </aside>

          {/* --- GŁÓWNA TREŚĆ (Prawa kolumna) --- */}
          <main className="interview__article">
            
            <header className="interview__article-header">
                <h1 className="interview__article-title">{interviewData.title}</h1>
                <h2 className="interview__article-subtitle">{interviewData.subtitle}</h2>
            </header>

            <div className="interview__intro">
                {interviewData.intro.map((paragraph, index) => (
                   <p key={index} className="interview__text-paragraph">
                       {paragraph}
                   </p>
                ))}
            </div>

            <hr className="interview__divider" />

            <div className="interview__content">
                {interviewData.sections.map((section, index) => (
                   /* Używamy React.Fragment, aby móc zwrócić sekcję ORAZ opcjonalne zdjęcie */
                   <React.Fragment key={index}>
                       
                       {/* Tekst Sekcji */}
                       <section className="interview__section">
                           <h3 className="interview__section-heading">
                               {section.title}
                           </h3>
                           <p className="interview__text-paragraph interview__text-paragraph--justify">
                               {section.content}
                           </p>
                       </section>

                       {/* --- LOGIKA WSTAWIANIA ZDJĘĆ --- */}
                       
                       {/* Zdjęcie 1: Po pierwszej sekcji (index 0) */}
                       {index === 0 && (
                           <div className="interview__image-wrapper">
                               <img 
                                   src={images.interview_1} 
                                   alt="Psychologia w naturze" 
                                   className="interview__article-image"
                               />
                               <span className="interview__image-caption">Kontakt z naturą wspiera proces terapeutyczny.</span>
                           </div>
                       )}

                       {/* Zdjęcie 2: Po trzeciej sekcji (index 2) */}
                       {index === 2 && (
                           <div className="interview__image-wrapper">
                               <img 
                                   src={images.interview_2} 
                                   alt="Rozmowa terapeutyczna" 
                                   className="interview__article-image"
                               />
                           </div>
                       )}

                       {/* Zdjęcie 3: Po piątej sekcji (index 4) */}
                       {index === 4 && (
                           <div className="interview__image-wrapper">
                               <img 
                                   src={images.interview_3} 
                                   alt="Spokój i równowaga" 
                                   className="interview__article-image"
                               />
                           </div>
                       )}

                   </React.Fragment>
                ))}
            </div>

            <footer className="interview__footer">
                <div className="interview__bibliography">
                   <h4>Bibliografia</h4>
                   <ul>
                       {interviewData.bibliography.map((item, index) => (
                           <li key={index}>{item}</li>
                       ))}
                   </ul>
                </div>
            </footer>

          </main>

        </div>
      </div>
    </div>
  );
}

export default Interview;